<script>
export default {
  name: "TheUserAccountMenu"
}
</script>

<template>
  <div id="submenu0-item0-content" class="px-3" aria-labelledby="submenu0-item0-header">
    <a class="submenu-item-link" href="/myaccount/profile">My Account Profile</a>
    <a class="submenu-item-link" href="/myaccount/order_history">Purchase History</a>
    <a class="submenu-item-link" href="/myaccount/selling_history">Selling History</a>
    <a class="submenu-item-link" href="/myaccount/wishlist">Wishlist</a>
    <a class="submenu-item-link"
       target="_blank" href="https://cardkingdom.freshdesk.com/support/home">Help</a>
    <a class="submenu-item-link" href="/customer_login/logout">Sign Out</a>
  </div>
</template>
